import React from 'react';
import { motion } from 'framer-motion';
import { X, Check } from 'lucide-react';
const comparisons = [{
  before: 'นั่งเขียนแผนการสอนใหม่ทุกสัปดาห์',
  after: 'มีแผนการสอนครบ 12 เดือนพร้อมใช้ทันที'
}, {
  before: 'ไม่รู้จะสอนอะไรวันที่ฝนตกหรือสนามเล็ก',
  after: 'มีเนื้อหาพร้อมสอนทุกคลาสไม่ว่าสภาพแวดล้อมจะเป็นอย่างไร'
}, {
  before: 'ผู้ปกครองถามผลลัพธ์แต่ไม่มีอะไรแสดง',
  after: 'มีรายงานผลสำหรับผู้ปกครองพร้อมใช้ทุกเดือน'
}, {
  before: 'นักเรียนไม่พัฒนาอย่างมีระบบ',
  after: 'ระบบประเมินผลรายบุคคลชัดเจนทุกระดับ'
}];
export function BeforeAfter() {
  return <section className="w-full bg-cream-bg py-20 px-4" data-id="element-26">
      <div className="max-w-6xl mx-auto" data-id="element-27">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-display font-bold text-center text-navy-primary mb-12" data-id="element-28">
          การเปลี่ยนแปลงที่คุณจะได้รับ
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-29">
          {/* Before Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50 rounded-xl p-6 border-2 border-red-200" data-id="element-30">
            <h3 className="text-2xl font-display font-bold text-red-700 mb-6 flex items-center gap-2" data-id="element-31">
              <X className="w-6 h-6" data-id="element-32" />
              ก่อนมีระบบ
            </h3>
            <div className="space-y-4" data-id="element-33">
              {comparisons.map((item, index) => <div key={index} className="flex gap-3" data-id="element-34">
                  <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-1" data-id="element-35" />
                  <p className="text-gray-700" data-id="element-36">{item.before}</p>
                </div>)}
            </div>
          </motion.div>

          {/* After Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-50 rounded-xl p-6 border-2 border-green-200" data-id="element-37">
            <h3 className="text-2xl font-display font-bold text-green-700 mb-6 flex items-center gap-2" data-id="element-38">
              <Check className="w-6 h-6" data-id="element-39" />
              หลังมีระบบ
            </h3>
            <div className="space-y-4" data-id="element-40">
              {comparisons.map((item, index) => <div key={index} className="flex gap-3" data-id="element-41">
                  <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-1" data-id="element-42" />
                  <p className="text-gray-700" data-id="element-43">{item.after}</p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}